import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const testimonials = [
  {
    name: '田中 誠一',
    role: '個人オーナー',
    image: 'https://public.readdy.ai/ai/img_res/179045c80087ccda9ff54a3ece3422c5.jpg',
    text: '株式会社永恒のおかげで、理想のマンションを手に入れることができました。担当者の方が丁寧に対応してくださり、安心して購入できました。品質の高さに大変満足しています。',
    rating: 5,
  },
  {
    name: '鈴木 美咲',
    role: '新築住宅オーナー',
    image: 'https://readdy.ai/api/search-image?query=professional%20Japanese%20woman%20smiling%20portrait%20warm%20friendly%20expression%20elegant%20casual%20attire%20confident%20trustworthy%20appearance%20natural%20light%20clean%20background&width=120&height=120&seq=testi-002&orientation=squarish',
    text: '家族の夢だったマイホームを永恒さんに建てていただきました。細部までこだわった設計と丁寧な施工で、毎日の暮らしが豊かになりました。本当にありがとうございます。',
    rating: 5,
  },
  {
    name: '山本 健太郎',
    role: '投資家',
    image: 'https://readdy.ai/api/search-image?query=professional%20Japanese%20senior%20businessman%20smiling%20portrait%20confident%20expression%20in%20business%20attire%20trustworthy%20appearance%20natural%20light%20clean%20background&width=120&height=120&seq=testi-003&orientation=squarish',
    text: '不動産投資のコンサルティングをお願いしました。市場分析から物件選定まで、専門的なアドバイスをいただき、安定した収益を得ることができています。信頼できるパートナーです。',
    rating: 5,
  },
  {
    name: '伊藤 さくら',
    role: '商業施設テナント',
    image: 'https://readdy.ai/api/search-image?query=professional%20Japanese%20young%20woman%20smiling%20portrait%20warm%20friendly%20expression%20business%20casual%20attire%20confident%20appearance%20natural%20light%20clean%20background&width=120&height=120&seq=testi-004&orientation=squarish',
    text: '永恒さんの商業施設にテナントとして入居しています。施設の管理が行き届いており、来店されるお客様からも好評です。快適なビジネス環境を提供していただいています。',
    rating: 5,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: featuredRef, isVisible: featuredVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: listRef, isVisible: listVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="testimonials" className="py-16 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className="text-center mb-12 md:mb-16"
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? 'translateY(0)' : 'translateY(32px)',
            transition: 'opacity 0.7s ease, transform 0.7s ease',
          }}
        >
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#B8960C]"></div>
            <span className="text-[#B8960C] text-xs tracking-[0.3em] font-medium uppercase">Testimonials</span>
            <div className="w-8 h-px bg-[#B8960C]"></div>
          </div>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-4"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            お客様の声
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            株式会社永恒をご利用いただいたお客様からの声をご紹介します。
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 md:gap-8 items-start">
          {/* Featured */}
          <div
            ref={featuredRef as React.RefObject<HTMLDivElement>}
            className="lg:col-span-2 bg-[#F8F6F1] p-6 md:p-10 rounded-sm relative overflow-hidden"
            style={{
              opacity: featuredVisible ? 1 : 0,
              transform: featuredVisible ? 'translateX(0)' : 'translateX(-40px)',
              transition: 'opacity 0.8s ease 0.1s, transform 0.8s ease 0.1s',
            }}
          >
            <div className="absolute top-4 right-4 md:top-6 md:right-8 text-[#B8960C]/10">
              <i className="ri-double-quotes-r text-[80px] md:text-[120px]"></i>
            </div>
            <div className="relative z-10">
              <div className="flex items-center gap-1 mb-4 md:mb-6">
                {[...Array(testimonials[active].rating)].map((_, i) => (
                  <div key={i} className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-[#B8960C]"></i>
                  </div>
                ))}
              </div>
              <p
                className="text-[#1A1A1A] text-base md:text-lg leading-relaxed mb-6 md:mb-8 italic"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                「{testimonials[active].text}」
              </p>
              <div className="flex items-center gap-3 md:gap-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden border-2 border-[#B8960C]/30 flex-shrink-0">
                  <img
                    src={testimonials[active].image}
                    alt={testimonials[active].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div
                    className="font-bold text-[#1A1A1A] tracking-wider text-sm md:text-base"
                    style={{ fontFamily: "'Noto Serif JP', serif" }}
                  >
                    {testimonials[active].name}
                  </div>
                  <div className="text-[#B8960C] text-xs md:text-sm">{testimonials[active].role}</div>
                </div>
              </div>
            </div>
          </div>

          {/* List */}
          <div
            ref={listRef as React.RefObject<HTMLDivElement>}
            className="flex flex-col gap-3"
            style={{
              opacity: listVisible ? 1 : 0,
              transform: listVisible ? 'translateX(0)' : 'translateX(40px)',
              transition: 'opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s',
            }}
          >
            {testimonials.map((t, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-sm text-left transition-all cursor-pointer border min-h-[44px] ${
                  active === i
                    ? 'border-[#B8960C] bg-[#B8960C]/5 shadow-md'
                    : 'border-gray-100 bg-white hover:border-[#B8960C]/40'
                }`}
                style={{
                  opacity: listVisible ? 1 : 0,
                  transform: listVisible ? 'translateY(0)' : 'translateY(16px)',
                  transition: `opacity 0.5s ease ${0.3 + i * 0.1}s, transform 0.5s ease ${0.3 + i * 0.1}s, border-color 0.2s ease, background-color 0.2s ease`,
                }}
              >
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-gray-100">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-[#1A1A1A] text-xs md:text-sm tracking-wider truncate">{t.name}</div>
                  <div className="text-gray-400 text-[10px] md:text-xs mt-0.5 truncate">{t.role}</div>
                </div>
                {active === i && (
                  <div className="ml-auto w-5 h-5 flex items-center justify-center text-[#B8960C] flex-shrink-0">
                    <i className="ri-arrow-right-s-line text-lg"></i>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}